/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

import React from 'react';

export const onClientEntry = () => {
  if (typeof window !== 'undefined') {
    try {
      const originalSetItem = window.localStorage.setItem;
      window.localStorage.setItem = function (key, value) {
        originalSetItem.apply(this, arguments);
        if (key === 'itemsCart' || key === 'cartInfo') {
          window.dispatchEvent(new CustomEvent('cart-updated'));
        }
      };

      const originalRemoveItem = window.localStorage.removeItem;
      window.localStorage.removeItem = function (key) {
        originalRemoveItem.apply(this, arguments);
        if (key === 'itemsCart' || key === 'cartInfo') {
          window.dispatchEvent(new CustomEvent('cart-updated'));
        }
      };

      const originalClear = window.localStorage.clear;
      window.localStorage.clear = function () {
        originalClear.apply(this, arguments);
        window.dispatchEvent(new CustomEvent('cart-updated'));
      };
    } catch (e) {
      console.error('Failed to patch localStorage for cart updates', e);
    }
  }
};